import { render, staticRenderFns } from "./AuthMethodSignup.vue?vue&type=template&id=1032a1b4&"
import script from "./AuthMethodSignup.vue?vue&type=script&lang=ts&"
export * from "./AuthMethodSignup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports